import http from "./httpService";

const apiEndpoint = "/client/payment";

export function getPayments(params = {}) {
  return http.get(apiEndpoint, { params });
}

export function getPaymentNav(params = {}) {
  return http.get(`${apiEndpoint}/nav`, { params });
}

export function getCounters() {
  return http.get(`${apiEndpoint}/counters/`);
}

export function getPayment(id) {
  return http.get(`${apiEndpoint}/${id}`);
}

export function getPaystackPublicKey() {
  return http.get(`/client/paystack/publickey`);
}

export function getPaymentOptions() {
  return http.get(`${apiEndpoint}/options`);
}

export function savePayment(payment) {
  if (payment.id) return;
  return http.post(apiEndpoint, payment);
}

export function verifyPayment(payment) {
  return http.post(`${apiEndpoint}/verify`, payment);
}
